/* eslint-disable */
import Vue from 'vue'
import store from '@/store/index'

import MainService from './MainService'

class Call {
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  makeCallSuccess (response:any) {
    store.state.call.createCall.response = response
    store.state.call.createCall.loading = false
  }

  makeCallError (error:any) {
    store.state.call.createCall.error = error
    store.state.call.createCall.loading = false
  }

  async makeCall (sessionId:Number) {
    const storage:any = store.state.storage

    const data = {
      route: 'ocular/widget/v2/call',
      params: <any>{
        origin_url: Vue.prototype.$widget.urlOrigin(),
        ot_codec: storage.codec,
        time_zone: Vue.prototype.$widget.getDevice().timeZone,
        questionnary_code: storage.form.code,
        channel: store.state.channel
      }
    }

    const country = Vue.prototype.$cityMap.country
    if (country) {
      data.params.iso = country.iso
    }

    if (storage.category) {
      data.params.category_id = storage.category.id
    }

    if (sessionId) {
      data.params.session_id = sessionId
    }

    const zohoLeadId = store.state.zohoLead.id
    if (zohoLeadId) {
      data.params.zoho_lead_id = zohoLeadId
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        this.makeCallSuccess(res)
      })
      .catch((error) => {
        this.makeCallError(error)
      })
  }

  // makeCall (sessionId:Number) {
  //   const storage:any = store.state.storage

  //   const data = {
  //     route: 'ocular/widget/v2/call',
  //     method: 'POST',
  //     params: <any>{
  //       origin_url: Vue.prototype.$widget.urlOrigin(),
  //       ot_codec: storage.codec,
  //       time_zone: Vue.prototype.$widget.getDevice().timeZone,
  //       questionnary_code: storage.form.code
  //     },
  //     successHandler: 'call.makeCallSuccess',
  //     errorHandler: 'call.makeCallError'
  //   }

  //   const country = Vue.prototype.$cityMap.country
  //   if (country) {
  //     data.params.iso = country.iso
  //   }

  //   if (storage.category) {
  //     data.params.category_id = storage.category.id
  //   }

  //   if (sessionId) {
  //     data.params.session_id = sessionId
  //   }

  //   if (this.parentLocation.organizationCode) {
  //     data.params.code = this.parentLocation.organizationCode
  //   }

  //   window.parent.postMessage(`mainService.apiRequest(${JSON.stringify(data)})`, '*')
  // }

  // ---------------------------------------------------------

  awaitingCammerSuccess (response: any) {
    // code here
    store.state.call.awaitingCammer.response = response
    store.state.call.awaitingCammer.loading = false
  }

  awaitingCammerError (error: any) {
    store.state.call.awaitingCammer.error = error
    store.state.call.awaitingCammer.loading = false
  }

  async initAwaitingCammer (params:any) {
    const data = {
      route: 'ocular/await-cammer',
      params
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        this.awaitingCammerSuccess(res)
      })
      .catch((error) => {
        this.awaitingCammerError(error)
      })
  }

  async awaitingCammer () {
    const storage:any = store.state.storage

    const data = {
      route: 'ocular/widget/v2/await-cammer',
      params: {
        session_id: storage.room.session.id
      }
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        this.awaitingCammerSuccess(res)
      })
      .catch((error) => {
        this.awaitingCammerError(error)
      })
  }

  async leaveQueue (session_id: number) {
    const data = {
      route: 'ocular/widget/v2/leave-session',
      params: { session_id }
    }

    return MainService.post(data)
  }

  async sessionChatPresignedUrl (filePath: string) {
    const data = {
      route: 'ocular/widget/session-chat/presigned-url',
      params: { filePath }
    }

    return MainService.get(data)
  }
}

Vue.prototype.$call = new Call()
const call = <any> new Call()
export default call

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    call[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
